/*
 * @Author: Tahiti
 * @Date: 2025-10-23 18:06:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-09 10:51:06
 * @Description:
 * @FilePath: /weryai-web/api/create.ts
 */
import { http } from '~/utils/request'
import type { CreateImageData, ApiResponse } from '~/types'

/**
 * @description: 文本创建图片
 * @return {*}
 */
export const createImageApi = (
    data: CreateImageData
): Promise<
    ApiResponse<{
        url: string
    }>
> => {
    return http.post(
        '/api/v1/auth/creative/img/text/to_img',
        data as unknown as Record<string, unknown>
    )
}

// 获取任务状态
export const getTaskStatusApi = (params: any) => {
    return http.get(`/backend/auth/task/${params.task_id}`, params)
}

// 获取任务生成结果详情
export const getTaskResultDetailApi = (params: any) => {
    return http.get(`/backend/auth/ad-creative-log/${params.id}`, params)
}

interface RecommendPromptData {
    aspect_ratio: string
    duration?: number
    lang?: string
    media_url?: string
    model: string
    prompt: string
    type?: string
}

// 推荐提示词
export const recommendPromptPromptApi = (data: RecommendPromptData) => {
    return http.post(
        '/api/v1/auth/creative/img/prompt/text_to_img/recommend',
        data as unknown as Record<string, unknown>
    )
}

// 获取当前操作所需积分
export const getActionCreditRequiredApi = (params: any) => {
    return http.get(
        `/api/v1/auth/workflow/credits/calculate/${params.workflowType}`,
        params
    )
}

/**
 * @description: 图片创建图片
 * @return {*}
 */
export const createImageToImageApi = (
    data: CreateImageData
): Promise<
    ApiResponse<{
        url: string
    }>
> => {
    return http.post(
        '/api/v1/auth/creative/img/to_img',
        data as unknown as Record<string, unknown>
    )
}

/**
 * @description: 文生视频
 * @param {any} data
 * @return {*}
 */
export const createTextToVideoApi = (data: any) => {
    console.log(data)

    return http.post('/api/v1/auth/creative/video/text/to_video', data)
}

/**
 * @description: 单图片创建视频
 * @param {any} data
 * @return {*}
 */
export const createImageToVideoSingleApi = (data: any) => {
    return http.post('/api/v1/auth/creative/video/image/to_video', data)
}

/**
 * @description: 多图片创建视频
 * @param {any} data
 * @return {*}
 */
export const createImageToVideoMultipleApi = (data: any) => {
    return http.post('/api/v1/auth/creative/video/image/multi_to_video', data)
}

/**
 * @description: 首尾帧创建视频
 * @param {any} data
 * @return {*}
 */
export const createImageToVideoFirstLastFrameApi = (data: any) => {
    return http.post(
        '/api/v1/auth/creative/video/image/fist_last_to_video',
        data
    )
}

/**
 * @description: Seedance 2.0 全能参考图生视频
 * @param {any} data
 * @return {*}
 */
export const createAlmightyReferenceToVideoApi = (data: any) => {
    return http.post(
        '/api/v1/auth/creative/video/almighty/reference/to_video',
        data
    )
}

/**
 * @description: 视频编辑
 * @param {any} data
 * @return {*}
 */
export const createVideoEditApi = (data: any) => {
    return http.post('/api/v1/auth/creative/video/edit', data)
}

// 批量生成

/**
 * @description: 批量生成文本转图片
 * @param {any} data
 * @return {*}
 */
export const createBatchGenerateTxtToImageApi = (data: any) => {
    return http.post('/api/v1/auth/creative/img/text/to_img/batch', data)
}

/**
 * @description: 批量生成图片转图片
 * @param {any} data
 * @return {*}
 */
export const createBatchGenerateImgToImageApi = (data: any) => {
    return http.post('/api/v1/auth/creative/img/to_img/batch', data)
}

interface DeleteBatchGenerateRecordData {
    id: number
    include_failed?: boolean
    result_urls?: string[]
}

/**
 * @description: 删除历史记录
 * @param {DeleteBatchGenerateRecordData} data
 * @return {*}
 */
export const deleteBatchGenerateRecordApi = (
    data: DeleteBatchGenerateRecordData
) => {
    return http.delete(
        '/backend/auth/ad-creative-history-record/delete',
        {},
        data as unknown as Record<string, unknown>
    )
}

/**
 * @description: 删除批量生成记录
 * @param {any} data
 * @return {*}
 */
export const deleteBatchGenerateRecordBatchApi = (
    data: DeleteBatchGenerateRecordData
) => {
    return http.delete(
        '/backend/auth/ad-creative-history-record/delete/batch',
        {},
        data as unknown as Record<string, unknown>
    )
}

// ========== 音乐生成 API ==========

/**
 * @description: 音乐生成请求参数
 */
export interface CreateMusicData {
    /** 参考音频名称 */
    audio_name?: string
    /** 版权保护开关，默认false */
    copyright_protection?: boolean
    /** 描述（创意描述/提示词） */
    description: string
    /** 性别 */
    gender?: string
    /** 歌词内容 */
    lyrics?: string
    /** 平台，默认 WEB */
    platform?:
        | 'ANDROID'
        | 'IPHONE'
        | 'IPAD'
        | 'WIN7PHONE'
        | 'WEB'
        | 'WINDOWS_PC'
        | 'DEFAULT'
    /** 公开可见性，默认true */
    public_visible?: boolean
    /** 参考音频URL */
    reference_audio?: string
    /** 风格标签（key: 枚举值, value: 中文名称） */
    styles?: Record<string, string>
    /** 视频时长（秒） */
    t?: number
    /** 音乐类型：VOCAL_SONG-人声歌曲，ONLY_MUSIC-纯音乐 */
    type: 'VOCAL_SONG' | 'ONLY_MUSIC'
}

/**
 * @description: 音乐生成响应
 */
export interface CreateMusicResponse {
    task_id: string
    task_status: string
}

/**
 * @description: 文生音乐
 * @param {CreateMusicData} data
 * @return {*}
 */
export const createTextToMusicApi = (data: CreateMusicData) => {
    return http.post<CreateMusicResponse>(
        '/api/v1/auth/creative/music/generate',
        data as unknown as Record<string, unknown>
    )
}

/**
 * @description: AI 生成歌词
 * @param {object} data
 * @return {*}
 */
export const generateLyricsApi = (data: {
    prompt: string
    tags?: string[]
    lang?: string
}) => {
    return http.post(
        '/api/v1/auth/creative/music/lyrics/generate',
        data as unknown as Record<string, unknown>
    )
}

/**
 * @description: 获取声线列表
 * @return {*}
 */
export const getVoiceListApi = () => {
    return http.get('/api/v1/auth/creative/music/voice/list')
}

// 获取当前操作所需积分  新版
export const getNewActionCreditRequiredApi = (params: any) => {
    return http.get(
        `/api/v1/auth/workflow/credits/calculate/v1/${params.workflowType}`,
        params
    )
}
